export let formatEventDate = (date) => {
    date = new Date(date);

    let day = date.getDate();
    if (`${day}`.length === 1) {
        day = `0${day}`;
    }

    return day + ". " + getMonthName(date.getMonth()).substring(0, 3);
}

export let formatShortEventDate = (date) => {
    date = new Date(date);

    let day = date.getDate();
    if (`${day}`.length === 1) {
        day = `0${day}`;
    }

    let month = date.getMonth()+1;
    if (`${month}`.length === 1) {
        month = `0${month}`;
    }

    return day + "." + month;
}

export let formatLongEventDate = (date) => {
    date = new Date(date);

    let day = date.getDate();
    if (`${day}`.length === 1) {
        day = `0${day}`;
    }

    let month = date.getMonth();
    if (`${month}`.length === 1) {
        month = `0${month}`;
    }

    return getWeekdayName(date.getDay()).substring(0, 2) + ". " + day + "." + month;
}

export const formatEventTimeDate = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return formatTime(start) + " - " + formatTime(end) + " Uhr";
}

export let formatEventTime = (event) => {
    const start = new Date(event.startDate);
    const end = new Date(event.endDate);

    return formatTime(start) + " - " + formatTime(end) + " Uhr";
}

export let formatTime = (time) => {
    let hours = time.getHours();
    if (`${hours}`.length === 1) {
        hours = `0${hours}`;
    }

    let minutes = time.getMinutes();
    if (`${minutes}`.length === 1) {
        minutes = `0${minutes}`;
    }

    return hours + ":" + minutes;
}

export let getMonthName = (month) => {
    const months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
    return months[month];
}

export let getWeekdayName = (date) => {
    const parsedDate = new Date(date);
    const weekdays = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    return weekdays[parsedDate.getDay()];
}

export let isSameDay = (date1, date2) => {
    date1 = new Date(date1);
    date2 = new Date(date2);
    return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
}
